import Actions from "@/elements/Actions";
import { Mixpanel } from "@/elements/Mixpanel";
import { cn } from "@/lib/utils";
import { useRouter } from "next/router";
import React, { useState } from "react";

export default function TopBar({
    stockDetails,
    section,
    optionChainAvailable,
    isFNO,
    active,
    setActive,
    isPaidUserPage
}) {
    const { replace, asPath } = useRouter();
    return (
        <div
            className={cn(
                `bg-white w-full overflow-x-auto pb-0.5 lg:pb-0 sticky top-0 font-Inter flex flex-row justify-between z-[8] shadow-sm max-h-[48px] `,
                {
                    "top-14 lg:top-[70px]": !isPaidUserPage
                }
            )}
        >
            {section
                ?.filter((f) => (isFNO ? true : f.id !== "fno"))
                ?.filter((f2) => (optionChainAvailable ? true : f2.id !== "option-chain"))
                ?.filter((f3) => (f3.id === "option-chain" ? isPaidUserPage : true))
                .map((ele) => (
                    <div
                        key={ele.id}
                        className={cn(
                            `whitespace-nowrap min-w-[120px] w-full p-2 pt-3 flex justify-center border-b-4 outline-none select-none cursor-pointer duration-300 ease-in-out text-sm lg:text-base border-[#E5E5E5] font-medium text-[#666666]`,
                            {
                                " border-[#00439D] text-[#00439D] font-semibold": active === ele.id
                            }
                        )}
                        onClick={() => {
                            Mixpanel.track("cta_clicked", {
                                page: isFNO ? "fno_sdp" : "index_sdp",
                                tab: ele.id
                            });
                            const tempPath = asPath?.split("?")?.[0];
                            if (tempPath?.includes("-share-price-today")) {
                                const path = tempPath?.includes("-share-price-today/")
                                    ? tempPath?.replace(
                                          tempPath?.split("/")?.[tempPath?.split("/")?.length - 1],
                                          ele.id
                                      )
                                    : `${tempPath}/${ele.id}`;
                                replace(path);
                            } else {
                                setActive(ele.id);
                            }
                        }}
                    >
                        {ele.text}
                    </div>
                ))}
        </div>
    );
}
